import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Medal, Flame } from 'lucide-react';

const AchievementBadges = ({ userId }) => {
  const { API } = useContext(AuthContext);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!userId) return;
    axios.get(`${API}/users/${userId}/achievements`)
      .then((res) => setData(res.data))
      .catch(() => setData(null));
  }, [API, userId]);

  if (!data) return null;

  return (
    <Card className="mb-6" dir="rtl" data-testid="achievement-badges">
      <CardHeader>
        <CardTitle className="text-xl flex items-center justify-between flex-wrap gap-2">
          <span className="flex items-center gap-2">
            <Medal className="w-5 h-5 text-amber-500" />
            תגי הישגים
            <span className="text-sm font-normal text-gray-400">({data.earned_count}/{data.badges.length})</span>
          </span>
          <span className="flex items-center gap-3 text-sm">
            {data.current_streak >= 2 && (
              <span className="flex items-center gap-1 bg-orange-100 text-orange-700 font-extrabold px-3 py-1 rounded-full" data-testid="current-streak">
                <Flame className="w-4 h-4 text-orange-500" />
                {data.current_streak} ברצף!
              </span>
            )}
            {data.best_streak >= 2 && (
              <span className="text-gray-400 font-medium">שיא: {data.best_streak} ניצחונות רצופים</span>
            )}
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
          {data.badges.map((b) => (
            <div
              key={b.id}
              data-testid={`badge-${b.id}`}
              title={b.desc}
              className={`flex flex-col items-center text-center rounded-xl border-2 p-3 transition-all ${
                b.earned
                  ? 'border-amber-300 bg-gradient-to-b from-amber-50 to-yellow-50 shadow-sm hover:shadow-md hover:-translate-y-0.5'
                  : 'border-gray-200 bg-gray-50 opacity-45 grayscale'
              }`}
            >
              <span className="text-3xl mb-1">{b.emoji}</span>
              <span className={`text-xs font-bold leading-tight ${b.earned ? 'text-amber-800' : 'text-gray-500'}`}>{b.name}</span>
              <span className="text-[10px] text-gray-400 leading-tight mt-0.5">{b.desc}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default AchievementBadges;
